import { memo } from 'react'

import dayjs from 'dayjs'
import * as _ from 'lodash-es'

import type { VaultSymbol } from '@repo/common/queries/products'
import { useGetVaultHistory } from '@repo/common/queries/vaults'

import { find_nav_of_date, to_apy } from '../VaultReturnMetrics'

export const VaultNav1yAPY = memo<{ symbol: VaultSymbol }>(
  function VaultNav1yAPY({ symbol }) {
    const { data: dailies } = useGetVaultHistory({ symbol })
    if (dailies == null) return null

    const today_nav = _.last(dailies)
    if (today_nav == null) return null

    const today_day = dayjs(today_nav.timestamp)

    const one_year_nav = find_nav_of_date(
      dailies,
      today_day.subtract(1, 'year'),
    )

    const apy = to_apy(one_year_nav, today_nav)

    return <>{apy}</>
  },
)
